import { useQuery, useQueryClient } from "@tanstack/react-query";

/**
 * @description
 * 서비스상 restAPI의 응답값의 캐싱은 필요가 없습니다.
 * 서비스 메모리내 동작되는 가공된 대이터 캐싱만을 다룹니다.
 */
interface UseCachedQueryOptions<T> {
	queryKey: string[];
	queryFn: () => Promise<T>;
	staleTime?: number;
	cacheTime?: number;
	enabled?: boolean;
}

export function useCachedQuery<T>({
	queryKey,
	queryFn,
	staleTime = 5 * 60 * 1000, // 5분
	cacheTime = 10 * 60 * 1000, // 10분
	enabled = true
}: UseCachedQueryOptions<T>) {
	const queryClient = useQueryClient();

	return useQuery({
		queryKey,
		queryFn: async () => {
			return queryFn();
		},
		// 초기 캐시 처리
		initialData: () => {
			const cachedData = queryClient.getQueryData<T>(queryKey);
			if (cachedData) {
				return cachedData;
			}
			return undefined;
		},
		staleTime,
		cacheTime,
		refetchOnMount: true,
		refetchOnReconnect: true,
		refetchOnWindowFocus: false,
		enabled: enabled && queryKey.length > 0 && queryKey.length === queryKey.filter((q) => q).length
	});
}
